import React from 'react';
import { Box, Typography } from '@mui/material';
import { emptyStateBoxStyles, emptyStateTextStyles } from '../../../constants/escalateQueryDialog';

/**
 * EmptyStateDisplay Component
 * Shows message when escalation is not available
 */
const EmptyStateDisplay = ({ message = 'Escalation is not available for your role.' }) => {
  return (
    <Box sx={emptyStateBoxStyles}>
      <Typography variant="body1" sx={emptyStateTextStyles}>
        {message}
      </Typography>
    </Box>
  );
};

export default EmptyStateDisplay;
